import api from '../../services/api'
import { TruckApi } from './truckTypes'

async function getById(truckId: string) {
  const response = await api.get<TruckApi>(`/truck/${truckId}`)
  return response.data
}

export const truckApi = { getById }
